exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap[data-v-4053ba98]{position:relative}.stars[data-v-4053ba98]{margin-right:10px}.stars.orange[data-v-4053ba98]{position:absolute;top:0;left:0}.description[data-v-4053ba98]{max-height:100px;overflow:hidden}.description.expanded[data-v-4053ba98]{max-height:none}.action img[data-v-4053ba98]{display:inline-block;-webkit-transition:all .2s ease;transition:all .2s ease}.action.expanded img[data-v-4053ba98]{-webkit-transform:rotate(90deg);transform:rotate(90deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4053ba98","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/frontend/js/components/ReviewSliderCard.vue
// module id = ZpZM
// module chunks = 0